import BookingCollectionLoader from './BookingCollectionLoader';

export default BookingCollectionLoader;
